<template>
  <TextBase
    is="span"
    :color="props.color"
    :size="props.size"
    :font="props.font"
    :dark="props.dark"
  >
    <slot />
  </TextBase>
</template>

<script setup>
import TextBase from './TextBase.vue'

// Span text should by default have no classes as to inherit whatever parent element it's located in
const props = defineProps({
  color: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '',
  },
  font: {
    type: String,
    default: '',
  },
  dark: {
    type: String,
  },
})
</script>
